const DRAWABLE_SELECTOR = 'path, line, polyline, polygon, circle, ellipse, rect'
const STROKE_DURATION = 900
const FILL_DURATION = 600
const STAGGER = 90

const hasStroke = (el) => {
  const stroke = el.getAttribute('stroke')
  return Boolean(stroke) && stroke !== 'none'
}

const hasFill = (el) => el.getAttribute('fill') !== 'none'

/**
 * Sets up the hidden "from" state for every shape before the SVG is first
 * painted, so nothing flashes fully drawn before scrolling into view.
 */
const prepareSvg = (svg) => {
  svg.querySelectorAll(`${DRAWABLE_SELECTOR}, text`).forEach((el, index) => {
    const delay = index * STAGGER
    const transitions = []
    const drawsStroke = el.tagName !== 'text' && hasStroke(el) && typeof el.getTotalLength === 'function'
    const fadesIn = el.tagName === 'text' || hasFill(el)

    if (drawsStroke) {
      const length = el.getTotalLength()
      el.style.strokeDasharray = String(length)
      el.style.strokeDashoffset = String(length)
      transitions.push(`stroke-dashoffset ${STROKE_DURATION}ms ease ${delay}ms`)
    }

    if (fadesIn) {
      el.style.opacity = '0'
      transitions.push(`opacity ${FILL_DURATION}ms ease ${delay}ms`)
    }

    if (transitions.length) el.style.transition = transitions.join(', ')
  })
}

const revealSvg = (svg) => {
  svg.querySelectorAll(`${DRAWABLE_SELECTOR}, text`).forEach((el) => {
    if (el.style.strokeDashoffset) el.style.strokeDashoffset = '0'
    if (el.style.opacity === '0') el.style.opacity = '1'
  })
}

/**
 * Animates SVGs marked with data-svg-animate="draw": stroked shapes draw
 * along their path length while filled shapes and text fade in alongside.
 */
export const initializeSvgDraw = () => {
  const svgs = document.querySelectorAll('[data-svg-animate="draw"]')
  if (!svgs.length) return

  svgs.forEach(prepareSvg)

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        revealSvg(entry.target)
        observer.unobserve(entry.target)
      })
    },
    { threshold: 0.3 }
  )

  svgs.forEach((svg) => observer.observe(svg))
}
